import React, { useState } from "react";
import "./db.scss";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "./Sidebar/Sidebar";
import { LogoutModal } from "./Db/Modals/LogoutModal";
import { Route, withRouter } from "react-router-dom";
import { Header } from "./Header";
import Profile from "./Db/Profile/Profile";
import Facilities from "./Db/Facilities/Facilities";
import Financials from "./Db/Financials/Financials";
import { Services } from "./Db/Sevices/Services";
import { ServicesOpen } from "./Db/Explore/services/ServicesOpen";
import NewFacility from "./Db/Facilities/NewFacility";
import NewDoctor from "./Db/Explore/addDoctor";
import ChangePassword from "./Db/ChangePassword/ChangePassword";
import BankDetails from "./Db/BankDetails/BankDetails";
import BankLayout from "./Db/BankDetails/BankLayout";
//import { navlinks } from "./constant";
import { getSession } from "../redux/actions/authActions";
import ExploreLayout from "./Db/Explore/ExploreLayout";
import OrderLayout from "./Db/Order/AddOrder/OrderLayout";
import Patient from "./Db/Patient/Patient";
import PatientProfileForm from "./Db/Explore/PatientProfile/PatientProfileForm";
import Order from "./Db/Order/Order";
import { OrderServicesOpen } from "./Db/Order/AddOrder/services/ServicesOpen";
import NewOrder from "./Db/Order/NewOrder";
import Fees from "./Db/Fees/Fees";
import Users from "./Db/Users/Users";
import UserProfile from "./Db/Users/UserProfile";
import Suggestion from "./Db/Suggestion/Suggestion";
import Payout from "./Db/Payout/Payout";
import PayoutFiles from "./Db/Payout/PayoutFiles";
import Layout from "./Layout";
import ChatLayout from "./Db/Messages/ChatLayout";
import { ProfileListexplore } from "./Db/Explore/PatientProfile/ProfileListexplore";
import { ProfileListOrder } from "./Db/Order/AddOrder/PatientProfile/ProfileListOrder";
import { navlinks } from "./constant";
import { useEffect } from "react";
import { Icon } from "@iconify/react";
import { imageUrls } from "../constants/images";

const DashboardLayout = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState(""); // Add search state
  const [hide, setHide] = useState(true);
  const [mobile, setMobile] = useState(false);
  const [show, setShow] = useState(false);
  const { role_id } = getSession();
  const roleID = role_id;

  const showMobile = () => {
    setMobile(!mobile);
  };
  const hideMobile = () => {
    setMobile(!mobile);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //const role = navlinks.roles.find((role) => role.role === roleID);
  const [navigationLinks, setNavigationLinks] = useState([]);

  useEffect(() => {
    const fetchNavigationLinks = () => {
      const role = navlinks.roles.find((role) => role.role === roleID);
      if (role) {
        setNavigationLinks(role.navigationLinks);
      } else {
        setNavigationLinks([]);
      }
    };

    fetchNavigationLinks();
  }, [roleID]);
  return (
    <Layout>
      <div className={`dblayout`}>
        <div className="desktop_dev">
          {hide ? (
            <Sidebar
              handleShow={handleShow}
              setShow={() => setShow(true)}
              show={show}
              mobile={mobile}
              setMobile={setMobile}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              navigationLinks={navigationLinks}
            />
          ) : (
            ""
          )}
        </div>

        <div className="mobile_dev">
          <Sidebar
            handleShow={handleShow}
            hideMobile={hideMobile}
            setShow={() => setShow(true)}
            searchQuery={searchQuery}
            show={show}
            mobile={mobile}
            setMobile={setMobile}
            setSearchQuery={setSearchQuery}
            navigationLinks={navigationLinks}
          />
        </div>
        <div
          className={` side_wrapper !ml-0 tab:!ml-[261px] bg-[#FAFAFB] relative ${hide ? "mrleft" : "mrRight"
            }`}
        >
          <div className="bg-white mainDiv sticky top-0 z-50">
            <Container fluid>
              <div className="flex justify-between items-center flex-nowrap">
                <div className="logo sm:hidden">
                  <div className="w-40">
                    <img src={imageUrls.logo} alt="logo" />
                  </div>
                </div>
                <div>
                  {" "}
                  <div className="hamburger mobile_dev sm:fixed left-8 top-5 z-50">
                    <Icon
                      icon="quill:hamburger-sidebar"
                      className="w-[30px] h-[30px] cursor-pointer"
                      onClick={() => setMobile(!mobile)}
                    />
                  </div>
                </div>
              </div>
            </Container>
          </div>

          <Container fluid>
            <Row className="bg-[#FAFAFB]">
              <Col className="p-0">
                {roleID === "5" && (
                  <>
                    <Route
                      exact
                      path="/dashboard/profile/"
                      component={Profile}
                    />
                    <Route exact path="/dashboard/" component={ExploreLayout} />
                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />

                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />

                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/explore/add-patient`}
                      component={PatientProfileForm}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />

                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />

                    {/* <Route
                    path={`/dashboard/bank-details`}
                    component={BankLayout}
                  />
                  <Route path={`/dashboard/new-bank`} component={BankDetails} /> */}

                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                  </>
                )}
                {roleID === "4" && (
                  <>
                    <Route
                      exact
                      path={`/dashboard/`}
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/facilities"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      path={`/dashboard/new-doctor`}
                      component={NewDoctor}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    {/* <Route     --Cosmas
                    path={`/dashboard/services`}
                    component={Services}
                  /> */}

                    <Route
                      exact
                      path="/dashboard/profile/"
                      component={Profile}
                    />
                    <Route
                      exact
                      path={`/dashboard/bank-details`}
                      // component={BankLayout}
                      render={(props) => (
                        <BankLayout {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-bank`}
                      component={BankDetails}
                    />

                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />

                    <Route
                      path={`/dashboard/financials`}
                      component={Financials}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />

                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />

                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />

                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />
                  </>
                )}
                {roleID === "3" && (
                  <>

                    <Route
                      exact
                      path="/dashboard/fees"
                      render={(props) => (
                        <Fees {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/user-profile`}
                      component={UserProfile}
                    />
                    <Route
                      exact
                      path="/dashboard/users"
                      render={(props) => (
                        <Users {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/facilities"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />

                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      path={`/dashboard/new-doctor`}
                      component={NewDoctor}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      path={`/dashboard/bank-details`}
                      component={BankLayout}
                    />
                    <Route
                      exact
                      path="/dashboard/profile"
                      component={Profile}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route exact path="/dashboard/" component={ExploreLayout} />
                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />

                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />

                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/explore/add-patient`}
                      component={PatientProfileForm}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />

                  </>
                )}
                {roleID === "1" && (
                  <>
                    <Route
                      exact
                      path="/dashboard/"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/user-profile`}
                      component={UserProfile}
                    />
                    <Route
                      exact
                      path="/dashboard/users"
                      render={(props) => (
                        <Users {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    <Route
                      exact
                      path="/dashboard/profile/"
                      component={Profile}
                    />

                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route
                      path={`/dashboard/bank-details`}
                      component={BankLayout}
                    />
                    <Route
                      path={`/dashboard/new-bank`}
                      component={BankDetails}
                    />
                  </>
                )}
                {roleID === "2" && (
                  <>

                    <Route
                      exact
                      path="/dashboard/fees"
                      render={(props) => (
                        <Fees {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/user-profile`}
                      component={UserProfile}
                    />
                    <Route
                      exact
                      path="/dashboard/users"
                      render={(props) => (
                        <Users {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/suggestion"
                      render={(props) => (
                        <Suggestion {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/facilities"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />

                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      path={`/dashboard/new-doctor`}
                      component={NewDoctor}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/bank-details`}
                      //component={BankLayout}
                      render={(props) => (
                        <BankLayout {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-bank`}
                      component={BankDetails}
                    />
                    <Route
                      exact
                      path="/dashboard/profile"
                      component={Profile}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route exact path="/dashboard/" component={ExploreLayout} />
                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />

                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />

                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/explore/add-patient`}
                      component={PatientProfileForm}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />
                    <Route
                      exact
                      path={`/dashboard/payout/`}
                      component={Payout}
                    />
                    <Route
                      exact
                      path={`/dashboard/payoutfiles/`}
                      component={PayoutFiles}
                    />
                  </>
                )}
              </Col>
            </Row>
            <LogoutModal show={show} handleClose={handleClose} />
          </Container>
        </div>
      </div>
    </Layout>
  );
};
export default withRouter(DashboardLayout);
